const uuidv5 = require('uuid/v5');
import firebase from 'firebase/app';
import 'firebase/auth';

export default class UUID {

    static random() {
        let user = firebase.auth().currentUser;
        let date = new Date().getTime();
        let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            let r = (date + Math.random() * 16) % 16 | 0;
            date = Math.floor(date / 16);
            return (c == 'x' ? r : (r&0x3|0x8)).toString(16);
        });
        return uuidv5(user.uid, uuid);
    }
}